var render, staticRenderFns
import script from "./Notes.vue?vue&type=script&lang=ts&"
export * from "./Notes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc26e11",
  null
  
)

export default component.exports